<template>


  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.saleOrderStatusNumber"
                               :path="currentPage.path"/>

          <small v-if="item.note !== ''"><br/>{{ item.note }}</small>

        </template>

        <template #cell(color)="{item}">
          <div class="mb-2 mr-2 badge badge-dot badge-dot-xl" :style="{'background-color': item.color}"></div>
        </template>

        <template #cell(typeOperation)="{item}">

          <div class="mb-2 mr-2 badge badge-focus" v-if="item.typeOperation === 1">Comum</div>
          <div class="mb-2 mr-2 badge badge-success" v-else-if="item.typeOperation === 2">Finalização com sucesso
          </div>
          <div class="mb-2 mr-2 badge badge-danger" v-else-if="item.typeOperation === 3">Finalização com erro (reprovado)</div>

        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">

          <t-list-actions-default :form-path="currentPage.path" :id="item.saleOrderStatusNumber"
                                  :userAuth="userAuth"/>


        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TriggerEventType from "@/model/types/resource/TriggerEventType";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'TypeStatusExpedition',
  data() {
    return {
      TriggerEventType,
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Status Pedidos"},
        {key: "color", label: "Cor"},
        {key: "typeOperation", label: "Tipo Operação"},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalCustomer: false,
      modalCustomerName: "",
      modalTriggerOperationStatusTriggerId: 0,

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'business-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openModalTrigger(id, name) {
      this.modalTrigger = true
      this.modalTriggerName = name
      this.modalTriggerOperationStatusTriggerId = id
    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
